import { Redirect } from 'react-router-dom';

import { SolaForceCookie, useCookie } from '~/hooks/useCookie';
import { LoadingView } from '~/scenes/PortalViews/components/LoadingView';
import { RedirectToPortalHomepage } from '~/scenes/PortalViews/components/RedirectToPortalHomepage';

export const RedirectToPortalContinue = () => {
  const { value: currentPageCookie } = useCookie(SolaForceCookie.CurrentPage);

  // For developer convenience, if cookie is set, redirect to last page user was on.
  // This redirect feature has been removed from regular users
  const { value: loginContinueLastPage } = useCookie(
    SolaForceCookie.Dev_LoginContinueOnLastPage,
  );

  // Continue where user left off
  if (currentPageCookie && loginContinueLastPage === 'true') {
    // Redirect to UI2 view
    if (currentPageCookie.startsWith('/v2')) {
      return <Redirect to={currentPageCookie.substring(3)} />;
    }

    // Redirect to Legacy view
    window.location.replace('/');
    return <LoadingView />;
  }

  // Continue to homepage
  return <RedirectToPortalHomepage />;
};
